import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: 'Add New Member',
      description: 'Register a new volunteer for seva',
      icon: 'UserPlus',
      color: 'primary',
      path: '/add-edit-member',
      shortcut: 'Ctrl+N'
    },
    {
      title: 'Manage Services',
      description: 'View and manage required services',
      icon: 'ClipboardList',
      color: 'warning',
      path: '/manage',
      shortcut: 'Ctrl+S'
    },
    {
      title: 'View Reports',
      description: 'Generate seva allocation reports',
      icon: 'BarChart3',
      color: 'success',
      path: '/reports',
      shortcut: 'Ctrl+R'
    },
    {
      title: 'Allocation Stats',
      description: 'Live sector allocated vs required counts',
      icon: 'LayoutGrid',
      color: 'primary',
      path: '/allocation-stats',
      shortcut: 'Ctrl+A'
    }
  ];

  const getActionStyles = (color) => {
    const styles = {
      primary: {
        bg: 'bg-primary/5',
        border: 'border-primary/20',
        icon: 'text-primary',
        hover: 'hover:bg-primary/10'
      },
      warning: {
        bg: 'bg-warning/5',
        border: 'border-warning/20',
        icon: 'text-warning',
        hover: 'hover:bg-warning/10'
      },
      success: {
        bg: 'bg-success/5',
        border: 'border-success/20',
        icon: 'text-success',
        hover: 'hover:bg-success/10'
      }
    };
    return styles[color] || styles.primary;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-spiritual-sm">
      <div className="mb-4">
        <h2 className="font-heading font-semibold text-lg text-foreground mb-2">
          Quick Actions
        </h2>
        <p className="text-sm text-muted-foreground">
          Frequently used management functions
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {quickActions.map((action) => {
          const actionStyles = getActionStyles(action.color);
          
          return (
            <div
              key={action.path}
              className={`
                ${actionStyles.bg} ${actionStyles.border} ${actionStyles.hover}
                border rounded-lg p-4 cursor-pointer transition-all duration-200
                group
              `}
              onClick={() => navigate(action.path)}
            >
              <div className="items-start">
                <div className='flex items-center'>
                                  <div className={`
                  mr-2 h-10 rounded-lg flex items-center justify-center
                  ${actionStyles.bg} ${actionStyles.border}
                  group-hover:scale-105 transition-transform duration-200
                `}>
                  <Icon 
                    name={action.icon} 
                    size={20} 
                    className={actionStyles.icon}
                  />
                </div>
                  <h3 className="font-heading font-medium text-foreground text-sm mb-1">
                    {action.title}
                  </h3>
                </div>

                
                <div className="flex-1 min-w-0">
                 
                  <div className="flex items-center justify-between">
                     <p className="text-xs text-muted-foreground mb-2">
                    {action.description}
                  </p>
                    <Icon 
                      name="ArrowRight" 
                      size={27} 
                      className="text-muted-foreground group-hover:text-primary transition-colors" 
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;